export const STATUS_COLORS = {
    AVAILABLE: { text: "AVAILABLE", color: "text-green-500" },
    NOT_FOUND: { text: "NOT FOUND", color: "text-red-500" },
    FORBIDDEN: { text: "FORBIDDEN", color: "text-red-500" },
    LOADING: { text: "...Loading", color: "text-yellow-500" },
  };

export const ALLOWED_FORMATS = ['mp3', 'flac', 'oga', 'wav'];